import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { toInteger, isNumber } from 'lodash';
import { isNullOrUndefined } from 'src/app/services/utils';
import { monthName } from '../common/core/common.constants';

@Injectable({
  providedIn: 'root'
})
export class DateFormatTransferService extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts = value.trim().split('/');
      if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
        return {day: toInteger(dateParts[0]), month: toInteger(dateParts[1]), year: toInteger(dateParts[2])};
      }
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    if (!isNullOrUndefined(date)) {
      return `${monthName[date.month - 1]}/${date.day}/${date.year}`;
    } else {
      return '';
    }
  }
}
